module.exports = __webpack_public_path__ + "static/image1-b55e5a6b73e4fa6e49d55070b7729312.jpeg";